import intlDateTimeFormatPolyfill from './intl-datetimeformat'

intlDateTimeFormatPolyfill('es')
intlDateTimeFormatPolyfill('ca')
intlDateTimeFormatPolyfill('de-DE')
